module.exports = __webpack_public_path__ + "static/projekt_indywidualny_c08-c570e96bbb93e8a64200c0b5d7cd7b9c.jpg";